function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "rgba(10,10,10,0.5)",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("line", {
  y1: 10.5,
  x2: 10.5,
  transform: "translate(24.601 19.301) rotate(90)",
  fill: "none",
  stroke: "#0a0a0a",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.863,10.863l-.679-.679L0,0",
  transform: "translate(24.601 10.199) rotate(90)",
  fill: "none",
  stroke: "#0a0a0a",
  strokeWidth: 3
});

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.8319dff4.svg";
export { ForwardRef as ReactComponent };